/** csi/widget/_svg/_Plugin */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-attr",
	"dojo/dom-class",
	"dijit/Menu",
	"dijit/MenuItem",
	"dijit/registry",
	"csi/_base/underscore",
	"csi/html",
	"csi/locale",
	"csi/view/ToolbarPlugin",
	"./PluginFactory",
	"./util",
	"dojo/text!./resources/MenuItem.html"
], function(declare,lang,domAttr,domClass,Menu,MenuItem,registry,_,html,locale,ToolbarPlugin,PluginFactory,util,menuItemTemplate) {

	return declare(ToolbarPlugin, {
		DOUBLE_CLICK_DELAY: 300,
		
		// Boolean: hide plugin when it becomes disabled
		bHideWhenDisabled: false,

		// Boolean: indicates if plugin applies to text
		bText: false,

		// String: CSS style managed by plugin (if any)
		cssStyle: null,

		// String: name of plugin
		pluginName: null,

		// Object: csi.widget.svgCanvas containing plugin
		editor: null,

		// Object: shortcut to utils
		util: null,

		// String: Extension point to convert value to required format from plugin format.
		encode: function(value) {
			return value;
		},

		// String: Extension point to convert value from required format to plugin format.
		decode: function(value) {
			return value;
		},

		/** @property {Function} onClickThrottled - use in place of onClick to prevent action from being invoked multiple times when double-clicked */
		// TODO - should probably apply by default to ToolbarPluginButton
		onClickThrottled: null,
		
		postMixInProperties: function() {
			// summary: initialize showLabel to false as parameter so it will be applied once DOM is created for widget
			this.inherited(arguments);

			if(this.showLabel && this.label) {
				this.params.showLabel = this.showLabel;
			} else {
				this.showLabel = this.params.showLabel = false;
			}
		},

		postCreate: function() {
			var self = this;
			var label = this.label;
			var title = this.title;

			this.inherited(arguments);

			if (this.params.showLabel) {
				this.set("label",  locale.resource(label));
			}

			if (title && ((title != label) || !this.params.showLabel)) {
				this.set("title", locale.resource(title));
			}

			if (this.bHideWhenDisabled) {
				domClass.add(this.domNode, "csi-canvas-hide-when-disabled");
			}

			// Needed for IE11 to display the title
			domAttr.set(this.domNode, "title", this.title);

			if (this.onClickThrottled) {
				this.onClick = _.throttle(function() {
					self.onClickThrottled();
				}, this.DOUBLE_CLICK_DELAY, {trailing: false});
			}
		},

		canShowPlugin: function() {
			// summary: show only on edit mode
			return !!this.editor.editMode;
		},

		enablePlugin: function(/*Shape[]*/shapes, /*Object*/shapeAttrs, /*Object*/textAttrs) {
			// summary: update plugin value based on selected shapes and attributes and return enabled status
			if (shapes && (shapeAttrs||textAttrs)) {
				if (this.bText) {
					// show text attributes for rectangle,ellipse and text
					return true;
				} else if (this.cssStyle) {
					return _.some(shapes, function(shape) { return shape.supportsStyle(this); }, this.cssStyle);
				}
			}

			return true;
		},

		getView: function() {
			// summary: access view directly through editor
			return this.editor.view;
		},

		// functions for text DropDownButtons
		createTextDropDownMenu: function(/*Object*/menuItems) {
			// summary: convenience function for text drop down widgets
			var self = this;
			var menu = new Menu();

			_.each(menuItems, function(menuItem) {
				var item = new MenuItem({
					templateString: menuItemTemplate,
					label: menuItem.label,
					onClick: function(e) {
						self.onClickDropDown(e,this);
					},
					value: menuItem.value
				});

				menu.addChild(item);
			});

			return menu;
		},

					// functions for icon DropDownButtons
		createDropDownMenu: function(/*Object*/icons) {
			// summary: convenience function for icon drop down widgets
			var self = this;
			var	menu = new Menu({
				"class": "csi-svg-menu",
				style: "display: none;"
			});

			_.each(icons, function(icon,i) {
				var item = new MenuItem({
					templateString: menuItemTemplate,
					iconClass: "csi-svg-menu-icon " + icon,
					onClick: function(e) {
						self.onClickDropDown(e,this);
					},
					value: i
				});

				menu.addChild(item);
			});

			return menu;
		},

		onClickDropDown: function(/*Event*/e) {
			// summary: apply style
			if (this.propertyKey) {
				this.editor.setShapeProperty(this.propertyKey, this.encode(registry.getEnclosingWidget(e.target).getIndexInParent()));
			} else {
				this.editor.setShapeStyle(this.cssStyle, registry.getEnclosingWidget(e.target).getIndexInParent());
			}
			this.editor.push();
		},

		openDropDown: function() {
			// summary: highlight menu item for current style value
			this.inherited(arguments);
		},

		closeDropDown: function() {
			// summary: enable keyboard handling of canvas now that drop down is closing
			if (this._opened) {
				this._blur();
			}

			this.inherited(arguments);
		},

		onFocus: function() {
			if (this.dropDown) {
				var self = this;

				_.defer(function() {
					if (!self._opened) {
						self._blur();
					}
				});
			}
		},

		_cssMouseEvent: function(/*Event*/event){
			// summary: ignore keydown or keyup events - this prevents Enter/Space key from triggering click event (even after blur)
			// Reference _CssStateMixin
			if (event.type == "keydown" || event.type == "keyup") {
				return;
			}

			this.inherited(arguments);
		},

		_onClick: function(e) {
			// summary: blur widget on click if so configured
			var ret = this.inherited(arguments);
			var focusFroala = this.pluginName !== "link";
			if (!this.dropDown) {
				this._blur(focusFroala);
			}
			return ret;
		},

		/**
		 * Disable ability to use keyboard to trigger events on widget (even after blur)
		 * @param focusFroala {Boolean} Flag to indicate whether to focus froala or not
		 */
		_blur: function(focusFroala) {
			// Reference a11yclick
			// ComboButton: buttonNode
			// DropDownButton: _buttonNode
			// Button: domNode.firstChild (dijitButtonNode)
			// Select: doesn't seem to be necessary
			var clickNode = this.buttonNode || this._buttonNode || this.domNode.firstChild;
			if (clickNode && clickNode.dojoClick) {
				clickNode.dojoClick = false;
			}
			this.editor.focus(focusFroala);

		}
	});
});
